/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/display-name */
import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { createTheme, ThemeProvider } from '@mui/material';
import ComponentLoader from './components/component-loader';
import getAllUrlParams from './util/get-url-params';
import AlertProvider from './managers/alert/alert-provider';
import LocaleEn from './resources/locales/en.json';
import styles from './app.module.scss';

const defaultTheme = createTheme();

const theme = createTheme({
  palette: {
    primary: {
      main: '#546E7A',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#77929E',
      contrastText: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: ['Rajdhani-Light'].join(','),
  },
  overrides: {
    MuiDialog: {
      paperFullWidth: {
        width: 'calc(100% - 24px)',
      },
      paperScrollPaper: {
        [defaultTheme.breakpoints.down('sm')]: {
          maxHeight: 'calc(100% - 100px)',
        },
      },
      paper: {
        marginLeft: '12px',
        marginRight: '12px',
      },
    },
    MuiDialogTitle: {
      root: {
        textAlign: 'center',
      },
    },
  },
});

const removeLoader = () => {
  window.removeLoader(300);
};
// Async components
const Landing = (props) => {
  const { match, location } = props || {};
  const { params } = match;
  const searchParams = getAllUrlParams(location.search);
  return (
    <ComponentLoader
      load={() => import('./features/landing')}
      props={{
        ...params,
        ...searchParams,
      }}
      onComplete={removeLoader}
    />
  );
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator', 'querystring', 'cookie', 'htmlTag'],
    },
    resources: { en: { translation: LocaleEn } },
  });

export default class App extends Component {
  render() {
    return (
      <>
        <ThemeProvider theme={theme}>
          <AlertProvider>
            <div className={styles.container}>
              <Router>
                <Switch>
                  <Route component={Landing} />
                </Switch>
              </Router>
            </div>
          </AlertProvider>
        </ThemeProvider>
      </>
    );
  }
}
